import React from "react";
import { Link } from "react-router-dom";
import logofondooscuro from "../../imagenes/logosnormales/logohorizont.svg";
import logofondoclaro from "../../imagenes/logosnormales/logoblanco.png";

class Navbar extends React.Component {
  componentDidMount() {
    // React 18 StrictMode double-invokes componentDidMount in development,
    // which would otherwise attach every listener below twice to the same
    // DOM nodes (e.g. the mobile-nav-toggle's classList.toggle firing twice
    // per click and cancelling itself out).
    if (this._navInitialized) return;
    this._navInitialized = true;

    let preloader = document.querySelector("#preloader");
    if (preloader) {
      window.addEventListener("load", () => {
        preloader.remove();
      });
    }

    let selectHeader = document.querySelector("#header");
    if (selectHeader) {
      const headerScrolled = () => {
        if (window.scrollY > 100) {
          selectHeader.classList.add("header-scrolled");
        } else {
          selectHeader.classList.remove("header-scrolled");
        }
      };
      window.addEventListener("load", headerScrolled);
      const onscroll = (el, listener) => {
        el.addEventListener("scroll", listener);
      };
      onscroll(document, headerScrolled);
    }

    const select = (el, all = false) => {
      el = el.trim();
      if (all) {
        return [...document.querySelectorAll(el)];
      } else {
        return document.querySelector(el);
      }
    };

    const on = (type, el, listener, all = false) => {
      let selectEl = select(el, all);
      if (selectEl) {
        if (all) {
          selectEl.forEach((e) => e.addEventListener(type, listener));
        } else {
          selectEl.addEventListener(type, listener);
        }
      }
    };

    const scrollto = (el) => {
      let header = select("#header");
      let offset = header.offsetHeight;

      let elementPos = select(el).offsetTop;
      window.scrollTo({
        top: elementPos - offset,
        behavior: "smooth",
      });
    };

    const onscroll = (el, listener) => {
      el.addEventListener("scroll", listener);
    };

    let backtotop = select(".back-to-top");
    if (backtotop) {
      const toggleBacktotop = () => {
        if (window.scrollY > 100) {
          backtotop.classList.add("active");
        } else {
          backtotop.classList.remove("active");
        }
      };
      window.addEventListener("load", toggleBacktotop);
      onscroll(document, toggleBacktotop);
    }

    on("click", ".mobile-nav-toggle", function (e) {
      select("#navbar").classList.toggle("navbar-mobile");
      this.classList.toggle("bi-list");
      this.classList.toggle("bi-x");
    });

    // Mega-menu hover-intent: the open panel spans the full header width,
    // so a column can sit under a *different* top-level item than the one
    // that opened it. Without this, briefly crossing that neighboring item
    // while moving the mouse down into the panel instantly steals hover and
    // swaps menus. Requiring a short dwell before opening (and a short
    // grace period before closing) lets incidental crossings pass through
    // without interrupting the menu the user is actually navigating.
    const megaDropdowns = select(".navbar li.mega-dropdown", true);
    megaDropdowns.forEach((li) => {
      let enterTimer = null;
      let leaveTimer = null;

      li.addEventListener("mouseenter", () => {
        clearTimeout(leaveTimer);
        if (li.classList.contains("mega-open")) return;
        enterTimer = setTimeout(() => {
          megaDropdowns.forEach((other) => {
            if (other !== li) other.classList.remove("mega-open");
          });
          li.classList.add("mega-open");
        }, 120);
      });

      li.addEventListener("mouseleave", () => {
        clearTimeout(enterTimer);
        leaveTimer = setTimeout(() => {
          li.classList.remove("mega-open");
        }, 200);
      });
    });

    on(
      "click",
      ".navbar .dropdown > a",
      function (e) {
        if (select("#navbar").classList.contains("navbar-mobile")) {
          e.preventDefault();
          this.nextElementSibling.classList.toggle("dropdown-active");
        }
      },
      true,
    );

    on(
      "click",
      ".scrollto",
      function (e) {
        if (select(this.hash)) {
          e.preventDefault();

          let navbar = select("#navbar");
          if (navbar.classList.contains("navbar-mobile")) {
            navbar.classList.remove("navbar-mobile");
            let navbarToggle = select(".mobile-nav-toggle");
            navbarToggle.classList.toggle("bi-list");
            navbarToggle.classList.toggle("bi-x");
          }
          scrollto(this.hash);
        }
      },
      true,
    );
  }

  render() {
    return (
      <React.Fragment>
        <header id="header" className="fixed-top ">
          <div className="container d-flex align-items-center">
            <h1 className="logo me-auto">
              <Link to="/" className="text-dark">
                <img
                  src={logofondooscuro}
                  className="logoflm-oscuro"
                  alt="logoFondoOscuro.png"
                />
                <img
                  src={logofondoclaro}
                  className="logoflm-claro"
                  alt="logoFondoclaro.png"
                />
              </Link>
            </h1>

            <nav id="navbar" className="navbar">
              <ul>
                <li className="dropdown mega-dropdown">
                  <a className="cursorp menu-link-su" href="#">
                    <span>Nosotros</span> <i className="bi bi-chevron-down"></i>
                  </a>
                  <div className="mega-menu">
                    <div className="mega-menu-inner">
                      <div className="mega-col">
                        <h6 className="mega-col-title">La Cooperativa</h6>
                        <ul>
                          <li>
                            <Link to={"/index"} className="link-menu">
                              Inicio
                            </Link>
                          </li>
                          <li>
                            <Link to={"/noticias"} className="link-menu">
                              Blog
                            </Link>
                          </li>
                          <li>
                            <Link to="/quienes-somos" className="link-menu">
                              ¿Quienes Somos?
                            </Link>
                          </li>
                          <li>
                            <Link to="/resena-historica" className="link-menu">
                              Reseña Histórica
                            </Link>
                          </li>
                          <li>
                            <Link to={"/saras"} className="link-menu">
                              SARAS
                            </Link>
                          </li>
                        </ul>
                      </div>
                      <div className="mega-col">
                        <h6 className="mega-col-title">Transparencia</h6>
                        <ul>
                          <li>
                            <Link
                              to={{
                                pathname: "/informacion-financiera",
                                search: "?tab=financiera",
                              }}
                              className="link-menu"
                            >
                              Información Financiera
                            </Link>
                          </li>
                          <li>
                            <Link
                              to={{
                                pathname: "/informacion-financiera",
                                search: "?tab=social",
                              }}
                              className="link-menu"
                            >
                              Información Social
                            </Link>
                          </li>
                          <li>
                            <Link
                              to={{
                                pathname: "/informacion-financiera",
                                search: "?tab=gobierno",
                              }}
                              className="link-menu"
                            >
                              Indicadores de Gobierno Cooperativo
                            </Link>
                          </li>
                          <li>
                            <Link
                              to={{
                                pathname: "/informacion-financiera",
                                search: "?tab=normativa",
                              }}
                              className="link-menu"
                            >
                              Normativa Interna
                            </Link>
                          </li>
                          <li>
                            <Link to="/cosede" className="link-menu">
                              Cosede
                            </Link>
                          </li>
                        </ul>
                      </div>
                      <div className="mega-col">
                        <h6 className="mega-col-title">Institucional</h6>
                        <ul>
                          <li>
                            <Link to="/agencias" className="link-menu">
                              Agencias
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/gobierno-corporativo"
                              className="link-menu"
                            >
                              Gobierno Corporativo
                            </Link>
                          </li>
                          <li>
                            <Link to={"/job-offersList"} className="link-menu">
                              Trabaja con nosotros
                            </Link>
                          </li>
                          <li>
                            <Link to="/codigo-etica" className="link-menu">
                              Código de Ética
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="dropdown mega-dropdown">
                  <a className="menu-link-su cursorp">
                    <span>Productos</span>{" "}
                    <i className="bi bi-chevron-down"></i>
                  </a>
                  <div className="mega-menu">
                    <div className="mega-menu-inner">
                      <div className="mega-col">
                        <h6 className="mega-col-title">
                          <i className="bi bi-piggy-bank menu-icon"></i>
                          Ahorros
                        </h6>
                        <ul>
                          <li>
                            <Link to="/cuenta-ahorros" className="link-menu">
                              Ahorro a la Vista
                            </Link>
                          </li>
                          <li>
                            <Link to="/ahorro-junior" className="link-menu">
                              Ahorro Junior
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/ahorro-programado"
                              className="link-menu"
                            >
                              Ahorro Programado
                            </Link>
                          </li>
                          <li>
                            <Link to="/ahorro-campo" className="link-menu">
                              Ahorro Campo
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/ahorro-inclusion"
                              className="link-menu"
                            >
                              Ahorro Inclusión
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/ahorro-inclusion-junior"
                              className="link-menu"
                            >
                              Ahorro Inclusión Junior
                            </Link>
                          </li>
                          <li>
                            <Link to="/ahorro-dual" className="link-menu">
                              Ahorro Dual
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/ahorro-inversion"
                              className="link-menu"
                            >
                              Depósito a Plazo Fijo
                            </Link>
                          </li>
                        </ul>
                      </div>
                      <div className="mega-col">
                        <h6 className="mega-col-title">
                          <i className="bi bi-cash-coin menu-icon"></i>
                          Créditos
                        </h6>
                        <ul>
                          <li>
                            <Link to="/credito-consumo" className="link-menu">
                              Crédito de Consumo
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/credito-inmobiliario"
                              className="link-menu"
                            >
                              Crédito Inmobiliario
                            </Link>
                          </li>
                          <li>
                            <Link to="/futu-hogar" className="link-menu">
                              Crédito Mi Futuro Hogar
                            </Link>
                          </li>
                        </ul>
                        <h6 className="mega-col-title mega-col-title-spaced">
                          <i className="bi bi-heart-pulse menu-icon"></i>
                          Beneficios
                        </h6>
                        <ul>
                          <li>
                            <Link to="/peluqueria" className="link-menu">
                              Peluquería
                            </Link>
                          </li>
                          <li>
                            <Link to="/odontologia" className="link-menu">
                              Odontología
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/medicina-general"
                              className="link-menu"
                            >
                              Medicina General
                            </Link>
                          </li>
                          <li>
                            <Link to="/fondo-mortuorio" className="link-menu">
                              Fondo Mortuorio
                            </Link>
                          </li>
                        </ul>
                      </div>
                      <div className="mega-col mega-col-wide">
                        <h6 className="mega-col-title">
                          <i className="bi bi-briefcase menu-icon"></i>
                          Microcréditos
                        </h6>
                        <ul className="mega-col-two-rows">
                          <li>
                            <Link to="/microcredito" className="link-menu">
                              Microcrédito
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/credito-autoliquidable"
                              className="link-menu"
                            >
                              Crédito Autoliquidable
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/credito-futuconfianza"
                              className="link-menu"
                            >
                              Crédito FuturoConfianza
                            </Link>
                          </li>
                          <li>
                            <Link to="/futu-auto" className="link-menu">
                              Crédito FutuAuto
                            </Link>
                          </li>
                          <li>
                            <Link to="/futu-salud" className="link-menu">
                              Crédito FutuSalud
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/credito-futuro-sobre-ruedas"
                              className="link-menu"
                            >
                              Crédito Futuro Sobre Ruedas
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/credito-futu-unido"
                              className="link-menu"
                            >
                              Crédito Futu Unido
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/credito-violeta"
                              className="link-menu"
                            >
                              Crédito Violeta
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/credito-premium"
                              className="link-menu"
                            >
                              Crédito Premium
                            </Link>
                          </li>
                          <li>
                            <Link to="/eco-futuro" className="link-menu">
                              Eco Futuro
                            </Link>
                          </li>
                          <li>
                            <Link to="/futu-papa" className="link-menu">
                              Crédito FutuPapá
                            </Link>
                          </li>
                          <li>
                            <Link to="/apoyo-futuro" className="link-menu">
                              Crédito Apoyo Futuro
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/emprende-futuro"
                              className="link-menu"
                            >
                              Crédito Emprende Futuro
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <Link to="/educacion-financiera" className="menu-link-su">
                    Educación Financiera
                  </Link>
                </li>
                <li className="dropdown mega-dropdown">
                  <a className="cursorp menu-link-su">
                    <span>En Línea</span> <i className="bi bi-chevron-down"></i>
                  </a>
                  <div className="mega-menu">
                    <div className="mega-menu-inner mega-menu-inner-compact">
                      <div className="mega-col">
                        <h6 className="mega-col-title">Servicios en línea</h6>
                        <ul>
                          <li>
                            <a
                              className="link-menu"
                              href="https://bdfl.futurolamanense.fin.ec/login"
                              target="_blank"
                            >
                              Banca Web
                            </a>
                          </li>
                          <li>
                            <a
                              className="link-menu"
                              href="https://solicitudcredito.futurolamanense.fin.ec/"
                              target="_blank"
                            >
                              Crédito en línea
                            </a>
                          </li>
                          <li>
                            <Link to="/futuro-premia" className="link-menu">
                              Gana puntos
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/guardianes-del-ahorro"
                              className="link-menu"
                            >
                              Guardianes del Ahorro
                            </Link>
                          </li>
                          <li>
                            <a
                              href="https://pagos.facilito.com.ec/aplicacion/futurolamanense"
                              target="_blank"
                              className="link-menu"
                            >
                              Portal de pagos
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="mega-col">
                        <h6 className="mega-col-title">Centro de ayuda</h6>
                        <ul>
                          <li>
                            <Link to="/horarios" className="link-menu">
                              Horarios de Atención
                            </Link>
                          </li>
                          <li>
                            <Link to="/contactos" className="link-menu">
                              Contáctanos
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="/quejas-reclamos-sugerencias"
                              className="link-menu"
                            >
                              Quejas, sugerencias y reclamos
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <a
                    className="getstarted scrollto"
                    href="https://bdfl.futurolamanense.fin.ec/login"
                  >
                    <i className="bi bi-box-arrow-in-right"></i>
                    Banca Web
                  </a>
                </li>
              </ul>
              <i className="bi bi-list mobile-nav-toggle"></i>
            </nav>
          </div>
        </header>
      </React.Fragment>
    );
  }
}

export default Navbar;
